import { render, staticRenderFns } from "./hi-checkbox.vue?vue&type=template&id=d382cf12"
import script from "./hi-checkbox.vue?vue&type=script&lang=ts"
export * from "./hi-checkbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports